<template>
  <div class="footer aRise">
    © 2020 YQ
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
  .footer{line-height: 75px; border-top: 1px solid #e8eaec; margin-top: 40px}
</style>



// WEBPACK FOOTER //
// src/public/MainFooter.vue